import React from 'react'
import { WrapGraphTexts } from './Style'

const StatsBar = (props) => {
    const { checkType, hideBarText, isBar } = props

    const checkTypeKeys = {
        "fluency": {
            text: "אחוז התלמידים",
            subText: "אחוז הקריאה בשטף"
        },
        "percent_accuracy": {
            text: "אחוז התלמידים",
            subText: "אחוז הדיוק"
        },
        "factored_percent_accuracy": {
            text: "אחוז התלמידים",
            subText: "אחוז הדיוק המשוקלל"
        },
        "words_per_minute": {
            text: "מספר התלמידים",
            subText: "מספר המילים לדקה"
        },
        "correct_words_per_minute": {
            text: "מספר התלמידים",
            subText: "מספר המילים הנכונות לדקה"
        },
        "non_self_corrected": {
            text: "אחוז התלמידים",
            subText: "אחוז טקסט ללא תיקון עצמי"
        },
        "non_minor_error": {
            text: "אחוז התלמידים",
            subText: "אחוז שגיאות קלות"
        }
    }

    const checkTypeItem = checkTypeKeys[checkType]

    return (
        !hideBarText &&
        <WrapGraphTexts>
            {isBar &&
                <div className='wrap-graph-text'>
                    <div className='graph-text'>
                        {checkTypeItem.text}
                    </div>
                </div>
            }
            <div className='wrap-graph-text'>
                <div className='graph-text'>
                    {checkTypeItem.subText}
                </div>
            </div>
        </WrapGraphTexts>
    )
}

export default StatsBar